/** Display dates as dd-mm-yyyy app-wide. Keep YYYY-MM-DD for APIs and <input type="date">. */

function pad2(n) {
  return String(n).padStart(2, '0');
}

/**
 * Format a date value for UI: dd-mm-yyyy.
 * Date-only strings (YYYY-MM-DD) are parsed without timezone shift.
 */
export function formatDateDisplay(value) {
  if (value == null || value === '') return '—';
  const s = String(value).trim();
  const dateOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateOnly) {
    return `${dateOnly[3]}-${dateOnly[2]}-${dateOnly[1]}`;
  }
  const d = value instanceof Date ? value : new Date(s);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

/** Format datetime for UI: dd-mm-yyyy HH:mm */
export function formatDateTimeDisplay(value) {
  if (value == null || value === '') return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
